import changeCities from "../modules/Utils/changeCities";
changeCities();

document.addEventListener('DOMContentLoaded', function () {
    // Initialize Swiper after it's loaded
    const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
            return;
        }

        const swiperProducts = new Swiper(".myProducts", {
            loop: true,
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 20,
            grabCursor: true,

            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    };

    initSwiper();

    // Script adaptado para controle de etapas, validação e bullets
    const form = document.getElementById('form-produto');
    const fieldsets = form.querySelectorAll('fieldset');
    const nextBtns = form.querySelectorAll('.next');
    const prevBtns = form.querySelectorAll('.prev');
    let currentStep = 0;

    // Criar bullets (exclui último fieldset de sucesso)
    const bulletsContainer = document.createElement('div');
    bulletsContainer.classList.add('form-bullets');

    for (let i = 0; i < fieldsets.length - 1; i++) {
        const bullet = document.createElement('span');
        bullet.classList.add('bullet');
        if (i === 0) bullet.classList.add('active');
        bulletsContainer.appendChild(bullet);
    }
    form.prepend(bulletsContainer);

    const updateSteps = () => {
        fieldsets.forEach((fs, i) => {
            fs.style.display = i === currentStep ? 'block' : 'none';
        });

        const bullets = form.querySelectorAll('.bullet');
        bullets.forEach((b, i) => {
            b.classList.toggle('active', i === currentStep);
        });
    };

    const validarStep = (stepIndex) => {
        const inputs = fieldsets[stepIndex].querySelectorAll('input, select, textarea');
        let valido = true;

        inputs.forEach(input => {
            if (!input.required) return;

            const isCheckbox = input.type === 'radio' || input.type === 'checkbox';
            const isFile = input.type === 'file';

            const vazio =
                (!isCheckbox && !isFile && !input.value.trim()) ||
                (isCheckbox && !input.checked && input.required) ||
                (isFile && input.required && input.files.length === 0);

            if (vazio) {
                input.classList.add('error');
                if (isCheckbox) {
                    input.closest('.d-flex')?.classList.add('error');
                }
                valido = false;
            } else {
                input.classList.remove('error');
                if (isCheckbox) {
                    input.closest('.d-flex')?.classList.remove('error');
                }
            }
        });

        return valido;
    };

    updateSteps();

    nextBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            if (!validarStep(currentStep)) return;

            if (currentStep < fieldsets.length - 2) {
                currentStep++;
                updateSteps();
            }
        });
    });

    prevBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            if (currentStep > 0) {
                currentStep--;
                updateSteps();
            }
        });
    });

    form.addEventListener('submit', function (e) {
        if (!validarStep(currentStep)) {
            e.preventDefault();
            return;
        }

        e.preventDefault();

        // Envio AJAX
        const url = form.getAttribute('data-url');
        const formData = new FormData(form);

        grecaptcha.ready(() => {
            grecaptcha.execute(document.getElementById("recaptcha").value, {
                action: 'submit'
            }).then(token => {
                formData.append('gRecaptchaResponse', token);
                fetch(url, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        // Redireciona para a página de sucesso
                        window.location.href = '/sucesso';
                    } else {
                        alert(data.txt || 'Erro ao enviar formulário.');
                    }
                })
                .catch(() => {
                    alert('Erro ao enviar formulário.');
                });
            });
        });
    });

    // Telefone mask
    document.getElementById('telefone').addEventListener('input', function (e) {
        let x = e.target.value.replace(/\D/g, '').slice(0, 11);
        if (x.length > 10) {
            e.target.value = x.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        } else {
            e.target.value = x.replace(/^(\d{2})(\d{4})(\d{0,4})$/, '($1) $2-$3');
        }
    });

    // Abrir/fechar formulário como modal no mobile
    const btnAbrir = document.querySelector('.abrir-form-vendedor');
    const btnFechar = document.querySelector('.formulario-produto .fechar-form');
    const formularioProduto = document.querySelector('.formulario-produto');

    if (btnAbrir && btnFechar && formularioProduto) {
        btnAbrir.addEventListener('click', () => {
            if (window.innerWidth <= 767) {
                formularioProduto.classList.add('modal-aberto');
                document.body.classList.add('modal-ativo');
            }
        });

        btnFechar.addEventListener('click', () => {
            formularioProduto.classList.remove('modal-aberto');
            document.body.classList.remove('modal-ativo');
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");

    accordionItems.forEach((item) => {
        const collapse = item.querySelector(".accordion-collapse");

        // Escuta o evento quando a FAQ é aberta
        collapse.addEventListener("show.bs.collapse", function () {
            item.classList.add("ativo");
        });

        // Escuta o evento quando a FAQ é fechada
        collapse.addEventListener("hide.bs.collapse", function () {
            item.classList.remove("ativo");
        });
    });
});
